module.exports = __webpack_public_path__ + "static/media/login.63c6450d.jpg";